var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trigger"},[_c('div',{class:_vm.type},[_c('span',{staticClass:"trigger-elem"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('span',{staticClass:"trigger-elem drop-in-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }